export default "__VITE_ASSET__Dsapje3x__"